// ################################### Working Diagnosis ###################################
export const smartDocParamCondition_WorkingDiagnosis_Exists = 'wd__exists';
export const smartDocParamCondition_WorkingDiagnosis_DoesNotExists = 'wd__does-not-exists';
export const smartDocParamCondition_WorkingDiagnosis = [smartDocParamCondition_WorkingDiagnosis_Exists,
    smartDocParamCondition_WorkingDiagnosis_DoesNotExists];
// ################################### Disposition Type ###################################
export const smartDocParamCondition_DispositionType_Null = 'dt__null';
export const smartDocParamCondition_DispositionType_Admit = 'dt__admit';
export const smartDocParamCondition_DispositionType_Discharge = 'dt__discharge';
export const smartDocParamCondition_DispositionType = [smartDocParamCondition_DispositionType_Null,
    smartDocParamCondition_DispositionType_Admit,
    smartDocParamCondition_DispositionType_Discharge];
//# sourceMappingURL=types.js.map